import React from "react";
import { Footer, Navbar } from "../components";
import { Header, Aplikasi } from "../components/CoilHitamPage.jsx";

const CoilHitam = () => {
  return (
    <>
      <Navbar />
      <section>
        <Header />
      </section>
      <section className="pt-10">
        <Aplikasi />
      </section>
      <Footer />
    </>
  );
};

export default CoilHitam;
